interface Props {
  onDigit: (d: string) => void;
  onBackspace: () => void;
  onSubmit: () => void;
  submitLabel?: string;
  disabled?: boolean;
}

/**
 * Big-touch-target numeric keypad. Lives in its own component so the PIN
 * screen, username screen, and any future numeric entry can reuse it.
 */
export function Keypad({
  onDigit,
  onBackspace,
  onSubmit,
  submitLabel = 'Enter',
  disabled = false,
}: Props) {
  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
  return (
    <div className="grid grid-cols-3 gap-3 w-72">
      {digits.map((d) => (
        <button
          key={d}
          type="button"
          disabled={disabled}
          onClick={() => onDigit(d)}
          className="h-16 rounded-xl bg-card text-2xl font-medium border border-border shadow-sm hover:opacity-80 active:scale-95 disabled:opacity-60"
        >
          {d}
        </button>
      ))}
      <button
        type="button"
        disabled={disabled}
        onClick={onBackspace}
        className="h-16 rounded-xl bg-muted text-base font-medium border border-border shadow-sm hover:opacity-80 active:scale-95 disabled:opacity-60"
      >
        ⌫
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onDigit('0')}
        className="h-16 rounded-xl bg-card text-2xl font-medium border border-border shadow-sm hover:opacity-80 active:scale-95 disabled:opacity-60"
      >
        0
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={onSubmit}
        className="h-16 rounded-xl bg-primary text-primary-foreground text-base font-medium shadow-md hover:opacity-90 active:scale-95 disabled:opacity-60"
      >
        {submitLabel}
      </button>
    </div>
  );
}
